// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bilan-alerte[data-v-79c85bb6] {\n  margin: 12px 0;\n  padding: 10px 14px;\n  border-left: 4px solid #f5a623;\n  background: #fff8e8;\n  color: #6b4a00;\n  font-size: 13px;\n  border-radius: 4px;\n}\n.bilan-alerte--forte[data-v-79c85bb6] {\n  border-left-width: 6px;\n  border-left-color: #e65100;\n  background: #fff0e0;\n  color: #7a2e00;\n  font-size: 14px;\n  font-weight: 600;\n}\n", ""]);
// Exports
module.exports = exports;
